import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const ContentWrapper = styled.div`
  padding: 16px;
  height: 100%;
  width: 60%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.gamma};
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.shades.gamma5};
  border-radius: 8px;
  padding: 16px;
  margin: 12px 0;
  background-color: ${colors.base.alpha};
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.shades.primary1};
  margin-bottom: 4px;
`;

const SectionHint = styled.div`
  font-size: 11px;
  line-height: 14px;
  color: ${colors.shades.gamma7};
  margin-bottom: 12px;
`;

/*
  The audience line is the one thing a coach must not miss before publishing — it is
  what tells them a save reaches live clients — so it is a filled callout rather than
  another line of grey hint text.
*/
const AudienceNote = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.shades.primary1};
  background-color: ${colors.base.gamma};
  border: 1px solid ${colors.shades.gamma5};
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
`;

const FieldLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.shades.primary1};
  margin-bottom: 8px;
`;

const SelectedProducts = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;

const SectionActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 12px;
`;

const EmptyState = styled.div`
  font-size: 13px;
  color: ${colors.shades.gamma7};
  padding: 16px 0;
  text-align: center;
`;

export {
  AudienceNote,
  ContentWrapper,
  EmptyState,
  FieldLabel,
  SectionActions,
  SectionContainer,
  SectionHint,
  SectionTitle,
  SelectedProducts,
};
